rs.module("content/jobs/benefitpayroll/index",

    [
        "controls/data/grid"
    ],

    function (gridModule) {

        //
        // Initialize the module
        //
        function initialize(jsSelectors, lrsGridApi, backendUrls) {

            // Unpack js selectors
            var filter = $.js(jsSelectors.filter);

            var batchStatusSelect = filter.js(jsSelectors.batchStatusSelect);
            var loadingSpinner = filter.js(jsSelectors.loadingSpinner);

            // Reload grid data when batch status filter changed
            batchStatusSelect.change(function () {
                reloadBenefitPayrollGrid();
            });

            //Using onjs() because only visible rows in the grid will have their contents rendered. 
            //Selecting by js selector and adding a click handler would only get click handlers hooked up for the visible rows.
            $(document).onjs('click', jsSelectors.readyToPostCheckbox, function () {

                var readyToPostCheckbox = $(this);

                //Get the rows update spinner and show it
                var spinner = $(this).siblingsjs(jsSelectors.readytoPostCheckboxSpinner);
                spinner.show();

                //Get the record key (PayrollBatchKey) associated to the grid row that the checkbox was changed
                var payrollBatchKey = readyToPostCheckbox.data("payrollbatchkey");

                //Make AJAX call to update the benefit payroll record
                $.post(
                    backendUrls.updateReadyToPostFlag,
                    { payrollBatchKey: payrollBatchKey, readyToPostFlag: readyToPostCheckbox.is(":checked") }
                ).done(function (data) {

                    //Hide row's update spinner
                    spinner.hide();

                    // Reload grid
                    reloadBenefitPayrollGrid(true);
                });
            });

            // Reload the Benefit Payroll Grid
            function reloadBenefitPayrollGrid(avoidSpinner) {
                if (!avoidSpinner) {
                    loadingSpinner.show();
                }

                var status = batchStatusSelect.val();
                gridModule.update(
                    backendUrls.getBenefitPayrollGrid,

                    { selectedStatus: status },

                    lrsGridApi.agGridApi,

                    function done() {
                        if (!avoidSpinner) {
                            loadingSpinner.hide();
                        }
                    }
                );
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);